// extracted by mini-css-extract-plugin
export default {"infoGrid":"InfoGrid_infoGrid__GR9c4","infoItem":"InfoGrid_infoItem__u03pX"};